export const CLIENT_ID = 'p3odvb3nuavlkk709e8hnm9d2';
export const REDIRECT_URI = 'https://demo.moyashi.link/api/auth/login/cognito';
export const LOGIN_SERVER = `https://auth.demo.moyashi.link/login?client_id=${CLIENT_ID}&response_type=code&scope=email+openid+phone&redirect_uri=${REDIRECT_URI}`;
